import {cssRule} from 'typestyle';
import {px, important} from 'csx';
import {BlackColor, LightGreyColor, WhiteColor} from './colors';

cssRule('.DateInput, .DateRangePickerInput', {
    display: 'flex',
    backgroundColor: 'transparent',
});

cssRule('.DateInput', {
    width: '100%',
});

cssRule('.DateInput_input', {
    textAlign: 'center',
    fontWeight: important('normal'),
    fontSize: important('1rem'),
    lineHeight: px(24),
    color: important(BlackColor),
    backgroundColor: 'transparent',
    width: '100%',
    padding: 3,
    border: 0,
    borderTop: 0,
    borderRight: 0,
    borderBottom: '2px solid transparent',
    borderLeft: 0,
});

cssRule('.DateInput_fang', {
    position: 'absolute',
    width: 20,
    height: 10,
    left: 22,
    zIndex: 2,
    marginTop: -25,
});

cssRule('.DateRangePicker_picker', {
    zIndex: 31,
    backgroundColor: WhiteColor,
    position: 'absolute',
    marginTop: -25,
});

cssRule('.DateRangePickerInput__withBorder', {
    borderColor: LightGreyColor,
    alignItems: 'center',
});



// WEBPACK FOOTER //
// ./src/styles/react-dates-overwrite.ts